export const breakpoints = {
  xs: 768,
  sm: 992,
  md: 1230,
  lg: 1440,
  xl: Infinity
}

export const currencyInputSettings = {
  decimal: '.',
  thousands: ',',
  prefix: '$',
  suffix: '',
  precision: 0,
  masked: false
};

export const LISTING_TYPES = {
  WEEKLY: 1,
  EXTENDED: 4,
  FIXED: 3,
  DONT_LIST: 0,
};

export const INTENT_TYPES = {
  VAULT: 1,
  PREMIER: 2,
  WEEKLY: 3,
  WEEKLY_WITH_GRADING_CGC: 4,
  WEEKLY_WITH_GRADING_BECKETT: 5,
  WEEKLY_WITH_GRADING_MBA: 6,
  VAULT_WITH_GRADING_MBA: 7,
  VAULT_WITH_GRADING_CGC: 8,
  VAULT_WITH_GRADING_BECKETT: 9,
  VAULT_WITH_GRADING_SGC: 10,
  WEEKLY_WITH_GRADING_SGC: 11,
  VAULT_WITH_GRADING_SGC_TCG: 12,
  WEEKLY_WITH_GRADING_SGC_TCG: 13,
  WEEKLY_WITH_GRADING_PSA: 14,
  VAULT_WITH_GRADING_PSA: 15,
};

/** All steps listed in the form */
export const SINGLE_SUBMISSION_STEPS = {
  1: {
    title: 'Submit From',
  },
  2: {
    title: 'Submission Type',
  },
  3: {
    title: 'Add Submission Details',
  },
  4: {
    title: 'Print Form & Add Tracking',
  },
  5: {
    title: 'Package Received',
  },
};

export const TYPES_SUBMIT_FROM = {
  VAULT: 1,
  IN_POSSESSION: 2,
  THIRD_PARTY: 3,
};

export const EYE_APPEAL_NAMES = {
  A: 'Eye Appeal - A',
  E: 'Eye Appeal - E',
  S: 'Eye Appeal - S',
}
